export const CSS_CLASSES = {
  ROOT: "Button",
  ICON: "b-icon",
  LABEL: "butlab",
  DENSE: "b-den",
  RAISED: "b-raised",
  OUTLINED: "b-out",
  UNELEVATED: "unel",
  UPPERCASE: "up-b",
};
